import React, { memo } from 'react';
import { type EntryPointProps, usePreloadedQuery, graphql } from 'react-relay';
import { useIntl } from '@atlassian/jira-intl';
import ViewNotFoundErrorPage from '@atlassian/jira-container-view-not-found-error-page/src/ui/ViewNotFoundErrorPage.tsx';
import type { ProjectViewNotFoundQuery } from '@atlassian/jira-relay/src/__generated__/ProjectViewNotFoundQuery.graphql';
import messages from './messages.tsx';

type Props = EntryPointProps<{ mainQuery: ProjectViewNotFoundQuery }, {}, {}, {}>;

const ProjectViewNotFound = ({ queries: { mainQuery } }: Props) => {
	const { formatMessage } = useIntl();
	const data = usePreloadedQuery<ProjectViewNotFoundQuery>(
		graphql`
			query ProjectViewNotFoundQuery($cloudId: ID!, $projectKey: String!) @preloadable {
				jira @required(action: THROW) {
					jiraProjectByKey(cloudId: $cloudId, key: $projectKey) {
						defaultNavigationItem {
							...ViewNotFoundErrorPage
						}
					}
				}
			}
		`,
		mainQuery,
	);

	return (
		<ViewNotFoundErrorPage
			scope="project"
			defaultNavigationItem={data.jira.jiraProjectByKey?.defaultNavigationItem}
			viewNotFoundDescription={formatMessage(messages.projectViewNotFoundDescription)}
			containerNotFoundDescription={formatMessage(messages.projectNotFoundDescription)}
			containerNotFoundButtonMessage={formatMessage(messages.goToBrowseProjects)}
			containerNotFoundRedirectUrl="/jira/projects"
		/>
	);
};

export default memo(ProjectViewNotFound);
